<div class="container-fluid mt-3 g-0 px-3">
    <!-- <button class="col-auto" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="getInterventionListFromMockedData()">
  <mat-icon class="material-symbols-outlined">upgrade</mat-icon>
</button> -->
    <div class="row ">
        @if (IsDevelopment) {
        <button appPreventDoubleClick class="col-auto" color="primary" mat-icon-button (throttledClick)="reset()" [disabled]="loadingTask.IsLoading">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
        </button>
        }
        @if (IsMobile) {
        <button appPreventDoubleClick class="col-12 col-md m-1" color="accent" mat-raised-button (throttledClick)="getMyIntervention()" [disabled]="loadingTask.IsLoading">
            Mes interventions
            <mat-icon class="material-symbols-outlined">get_app</mat-icon>
        </button>

        <button appPreventDoubleClick class="col-12 col-md m-1" color="warn" mat-raised-button (throttledClick)="getMyIntervention(true)" [disabled]="loadingTask.IsLoading">
            Dernière minute !
            <mat-icon class="material-symbols-outlined">get_app</mat-icon>
            <mat-icon class="material-symbols-outlined">warning</mat-icon>
        </button>
        }
        @if (!IsMobile) {

        <div class="col-12 col-md-4">
            <mat-form-field class="w-100">
                <mat-label>Recherche par Code OGI, Code client, ...</mat-label>
                <input matInput [(ngModel)]="SearchText" placeholder="Code OGI, Code client, ...">
                @if (SearchText) {
                <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()" [disabled]="loadingTask.IsLoading">
                    <mat-icon class="material-symbols-outlined">close</mat-icon>
                </button>
                }
            </mat-form-field>
        </div>
        <div class="col-12 col-md-auto m-1 ">
            <button appPreventDoubleClick class="w-100 h-75" color="primary" mat-raised-button (throttledClick)="searchIntervention()" [disabled]="loadingTask.IsLoading">
                Rechercher
                <mat-icon class="material-symbols-outlined">search</mat-icon>
            </button>
        </div>
        <div class="col-12 col-md-auto m-1 ">
            <button appPreventDoubleClick class="w-100 h-75" mat-raised-button (throttledClick)="openDocumentDialog()" [disabled]="loadingTask.IsLoading">
                Envoyer un fichier de résultats
                <mat-icon class="material-symbols-outlined">description</mat-icon>
            </button>
        </div>
        }
    </div>

    @if (IsMobile) {
    <div class="row justify-content-center my-2">
        <mat-slide-toggle class="col-auto" [checked]="checked" (change)="change($event)" [disabled]="loadingTask.IsLoading">Afficher les terminées</mat-slide-toggle>
    </div>
    }
    <div class="row">
        @for (int of FilteredInterventionList; track int; let i = $index) {
        <div class="col-12 col-md-4 col-xl-2 p-1 ">
            <div class="h-100 m-3">
                <div class="row left-card-border border rounded-1 background-light " [style.border-left-color]="getColorByInterventionIndex(int.Status)"
                     (click)="IsMobile ? navigatoToIntervention(int, int.AdresseChantier): navigateToPlan(int)">

                    <div class="col ms-1 p-1">
                        <div class="row">
                            @if (int.IsLastMinute) {
                            <div class="col-auto">

                                <mat-icon class="material-symbols-outlined" color="warn">
                                    warning
                                </mat-icon>
                            </div>
                            }
                            <span class="col text-center"> {{int.NomChantier}} </span>

                            @if (int.IsLastMinute) {
                            <div class="col-auto">
                                <mat-icon class="material-symbols-outlined" color="warn">
                                    warning
                                </mat-icon>
                            </div>
                            }
                        </div>
                        <div class="row">
                            <span class="my-2 col text-center"> {{int.AdresseChantier}} </span>
                        </div>

                        <div class="row mt-2 justify-content-between mt-3 p-1 g-0">
                            <span class="col-auto text-center fst-italic my-auto mb-0"> {{int.PlannedDate.toLocaleString() }} </span>
                            <span class="col-auto"></span>
                            <div class="col-auto">

                                @if (IsMobile && int.Status !== EInterventionStatus.Preview) {
                                <button appPreventDoubleClick mat-mini-fab color="primary" class="col-auto text-center mx-1 mat-elevation-z0" (throttledClick)="handleSync(int.Code)"
                                        [disabled]="loadingTask.IsLoading">
                                    <mat-icon class="material-symbols-outlined">
                                        cloud_upload
                                    </mat-icon>
                                </button>
                                }
                                @if (IsMobile && int.Status !== EInterventionStatus.Done && int.Status !== EInterventionStatus.Preview) {
                                <button appPreventDoubleClick mat-mini-fab color="primary" class="col-auto text-center mx-1 mat-elevation-z0"
                                        [disabled]="loadingTask.IsLoading"
                                        (throttledClick)="handleSync(int.Code, $event, true)">
                                    <mat-icon class="material-symbols-outlined"> done </mat-icon>
                                </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
</div>